export default __webpack_public_path__ + "static/media/bussolar1.784068b7.jpeg";